import { ItemName, Locale } from '@ps-smart-cp/ppfw-client';

const buttonNames = {
  toNext: ItemName.of([Locale.ja, '次へ']),
  login: ItemName.of([Locale.ja, 'ログイン']),
  cancel: ItemName.of([Locale.ja, 'キャンセル']),
  continueWithSso: ItemName.of([Locale.ja, 'SSOで続ける']),
  return: ItemName.of([Locale.ja, '戻る']),
  stop: ItemName.of([Locale.ja, '中止']),
  autoJudge: ItemName.of([Locale.ja, '自動判定']),
};

const labelNames = {
  organizationId: ItemName.of([Locale.ja, '組織ID']),
  userId: ItemName.of([Locale.ja, 'ユーザーID']),
  email: ItemName.of([Locale.ja, 'メールアドレス']),
  password: ItemName.of([Locale.ja, 'パスワード']),
  display: ItemName.of([Locale.ja, '表示']),
  hidden: ItemName.of([Locale.ja, '非表示']),
  sandbox: ItemName.of([Locale.ja, 'Sandbox']),
  range: ItemName.of([Locale.ja, '範囲']),
  importConfirmRecordSizeTip: ItemName.of(
    [Locale.ja, '{0}件のデータを取り込みます。'],
    [Locale.en, 'Import {0} records.'],
  ),
  importConfirmTip: ItemName.of([Locale.ja, 'よろしいですか?'], [Locale.en, 'Are you sure?']),
  selectDataFileToImport: ItemName.of(
    [Locale.ja, '取り込むデータファイルを選択してください。'],
    [Locale.en, 'Select data file to import'],
  ),
  useInputSupport: ItemName.of([Locale.ja, '入力補助を使用する'], [Locale.en, 'Use Input Support']),
  impairmentInfo: ItemName.of([Locale.ja, '減損情報']),
  depreciationItemChangeInfo: ItemName.of([Locale.ja, '償却項目変更情報']),
  acquiredMergerInfo: ItemName.of([Locale.ja, '合併受入情報']),
  leaseInformation: ItemName.of([Locale.ja, 'リース情報']),
  autoJudgeInfo: ItemName.of([Locale.ja, '自動判定情報']),
  autoJudge: ItemName.of([Locale.ja, '自動判定']),
  leaseAssetInfo: ItemName.of([Locale.ja, 'リース資産情報']),
  autoJudgeResultInfo: ItemName.of([Locale.ja, '自動判定結果情報']),
  count: ItemName.of([Locale.ja, '件']),
  judgeResultInfo: ItemName.of([Locale.ja, '判定結果情報']),
  execute: ItemName.of([Locale.ja, '行う']),
};

const linkNames = {
  adminHere: ItemName.of([Locale.ja, '管理者はこちら']),
  sandboxLoginHere: ItemName.of([Locale.ja, 'Sandboxへのログインはこちら']),
  selectCompany: ItemName.of([Locale.ja, '会社を選択']),
  toMainMenu: ItemName.of([Locale.ja, 'メインメニューへ']),
  toSystemManagement: ItemName.of([Locale.ja, 'システム管理']),
  changePassword: ItemName.of([Locale.ja, 'パスワード変更']),
  logout: ItemName.of([Locale.ja, 'ログアウト']),
};

const titleNames = {
  login: ItemName.of([Locale.ja, 'ログイン']),
  adminLogin: ItemName.of([Locale.ja, '管理者のログイン']),
  sandboxLogin: ItemName.of([Locale.ja, 'Sandboxへのログイン']),
};

export const ui = {
  linkNames,
  labelNames,
  titleNames,
  buttonNames,
};
